var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-container",class:_vm.classes},[_c('div',{staticClass:"progress"}),_c('div',{staticClass:"d-flex"},[_c('v-alert',{staticClass:"mb-0 flex-grow-1",attrs:{"message":_vm.alert.message,"type":_vm.alert.type}}),_c('div',{staticClass:"close",on:{"click":_vm.dismiss}},[_c('i',{staticClass:"fas fa-times"})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }